import React from "react";
import styles from "./header.module.css";
import RubberBand from 'react-reveal/RubberBand';
import Slide from 'react-reveal/Slide';
const Header = () => {
  return (
    <div id="header">
      <div className={styles.header}>
        <div className={styles.sub_header}>
        <RubberBand>
          <h1>Susmita Mandal</h1>
        </RubberBand>
        <Slide left>
          <p>Passionate about changing the world with technology.</p>
          </Slide>
          <Slide right>
          <div>
            <a href="https://github.com/Susmita549" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="black"
                class="bi bi-github"
                viewBox="0 0 16 16"
              >
                <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
              </svg>
            </a>
            <a href="https://www.linkedin.com/in/susmitamandal549/" target="_blank">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="black"
                class="bi bi-linkedin"
                viewBox="0 0 16 16"
              >
                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
              </svg>
            </a>
            <a href="mailto:jsusmita549@email.com?subject=subject&cc=susmitamandal1811@gmail.com" target="_blank">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="black"
                class="bi bi-envelope-open-fill"
                viewBox="0 0 16 16"
              >
                <path d="M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.314l6.709 3.932L8 8.928l1.291.718L16 5.714V5.4a2 2 0 0 0-1.059-1.765l-6-3.2ZM16 6.873l-5.693 3.337L16 13.372v-6.5Zm-.059 7.611L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516ZM0 13.373l5.693-3.163L0 6.873v6.5Z" />
              </svg>
            </a>

            <a href="tel:6370507147" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="black"
                class="bi bi-telephone-fill"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                />
              </svg>
            </a>
            <a href="https://drive.google.com/file/d/1Y9Vt5cehW272YJvOsN3KsVDPuJsaaKuC/view?usp=sharing" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="black"
                class="bi bi-file-earmark-person-fill"
                viewBox="0 0 16 16"
              >
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 5.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.245S4 12 8 12s5 1.755 5 1.755z" />
              </svg>
            </a>
          </div>
          </Slide>
          {/* <button type="button" className="btn btn-outline-warning">
            Scroll Down to know more 😃
          </button> */}
        </div>
        <div>
          <div className="spinner-grow text-primary" role="status">
            <span className="visually-hidden"></span>
          </div>
          <div className="spinner-grow text-secondary" role="status">
            <span className="visually-hidden"></span>
          </div>
          <div className="spinner-grow text-success" role="status">
            <span className="visually-hidden"></span>
          </div>
          <div className="spinner-grow text-danger" role="status">
            <span className="visually-hidden"></span>
          </div>
          <div className="spinner-grow text-warning" role="status">
            <span className="visually-hidden"></span>
          </div>
          <div className="spinner-grow text-info" role="status">
            <span className="visually-hidden"></span>
          </div>
          <div className="spinner-grow text-light" role="status">
            <span className="visually-hidden"></span>
          </div>
          <div className="spinner-grow text-dark" role="status">
            <span className="visually-hidden"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
